<!--suppress ALL -->
<template>
    <v-container>
        <v-layout>
            <v-flex xs12 class="no-padding-top">
                <div class="symptoms-container">

                    <!-- SubChapters ARE available -->
                    <v-expansion-panel expand v-if="getActiveChapter && getHasSubchapters" id="v_expansion_panel">
                        <v-expansion-panel-content v-for="subchapter in getActiveChapter.subChapters"
                                                   :id="'vExpansionPanelContentSubchapter_' + subchapter.code"
                                                   :ref="'vExpansionPanelContentSubchapterRef_' + subchapter.code"
                                                   :key="subchapter.code"
                                                   :value="navExpandSubchapter(subchapter.code) || navMustShowSubchapterExpanded(subchapter)"
                                                   class="expansion-list"
                                                   :class="{'panel-highlighted': shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === true
                                                                                 && shortcutNav.crtPanel === 'SUBCHAPTER' && shortcutNav.crtSubchapter === subchapter.code}"

                        >

                            <div :ref="'vExpansionPanelHeader_' + subchapter.code"
                                 :id="'SUBCHAPTER_' + subchapter.code"
                                 slot="header"
                                 class="font-size-medium font-weight-regular">

                                {{subchapter.name}}
                            </div>
                            <div
                                slot="actions"
                                class="svg-wrapper"
                                :style="{
                                    'width': 30 + 'px',
                                    'height': 30 + 'px'
                                }"
                            >
                                <ExpandIcon v-if="!(navExpandSubchapter(subchapter.code) || navMustShowSubchapterExpanded(subchapter))" :width="30" :height="30"/>
                                <CollapseIcon v-else :width="30" :height="30"/>
                            </div>

                            <v-card :ref="'vExpansionPanelBody_' + subchapter.code">
                                <v-card-text>
                                    <v-radio-group v-model="getSelectedMainSymptomCode">
                                        <v-radio v-for="symptomObj in subchapter.symptoms"
                                                 :key="symptomObj.code"
                                                 :ref="'vRadioSymptomsWithSubchaptersRef_' + symptomObj.code"
                                                 :id="'S_CHAPTER_TREE_RADIO_' + symptomObj.code"
                                                 :label="symptomObj.name"
                                                 :value="symptomObj.code"
                                                 @change="handleSymptomSelection"
                                                 color="primary"
                                                 class="margin-bottom-m check-main-symptom"
                                                 :class="{'symptom-highlighted': shortcutNav.isKeyboardNav === true && !mustShowScoringPopup && !showComment && shortcutNav.isPanelHighlight === false
                                                                                 && shortcutNav.crtPanel === 'SYMPTOM' && shortcutNav.crtSymptom === symptomObj.code}">

                                        </v-radio>
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- SubChapters are NOT available -->
                    <v-card v-if="getActiveChapter && !getHasSubchapters" class="no-chapter-list component-bg-color"
                            ref="vCardSymptomPanelRef"
                            :class="{'panel-highlighted': shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === true
                                                          && shortcutNav.crtPanel === 'SYMPTOM'}">
                        <v-card-text v-if="getActiveChapter.name">
                            {{getActiveChapter.name}} {{text('pro.chooseMainSymptomPage.chapter')}}
                        </v-card-text>
                        <v-radio-group v-model="getSelectedMainSymptomCode" >
                            <v-radio v-for="symptom in getActiveChapter.symptoms"
                                     :key="symptom.code"
                                     :label="symptom.name"
                                     :value="symptom.code"
                                     :ref="'vRadioSymptomsWithoutSubchaptersRef_' + symptom.code "
                                     :id="'S_CHAPTER_TREE_RADIO_' + symptom.code "
                                     @change="handleSymptomSelection"
                                     color="primary"
                                     class="margin-bottom-m check-main-symptom"
                                     :class="{'symptom-highlighted': shortcutNav.isKeyboardNav === true && !mustShowScoringPopup && !showComment && shortcutNav.isPanelHighlight === false
                                                                     && shortcutNav.crtPanel === 'SYMPTOM' && shortcutNav.crtSymptom === symptom.code}"
                            >
                            </v-radio>
                        </v-radio-group>
                    </v-card>

                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import Vue from "vue";
import ExpandIcon from "../../../common/components/svg/shared/ExpandIcon";
import CollapseIcon from "../../../common/components/svg/shared/CollapseIcon";
import axios from 'axios/dist/axios';

export default {
        name: 'Symptoms',
    components: {CollapseIcon, ExpandIcon},
    props: [
            'chooseSymptomChapter',
            "shortcutNav",
            "showComment"
        ],

        data() {
            return {
                radioGroup: '',
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg
            }
        },

        computed: {
            ...mapGetters({
                getSearchSymptomResultList: 'ChooseMainSymptomStore/getSearchSymptomResultList',
                getActiveChapter: 'ChooseMainSymptomStore/getActiveChapter',
                getHasSubchapters: 'ChooseMainSymptomStore/getHasSubchapters',
                getSelectedMainSymptomCode: 'ChooseMainSymptomStore/getSelectedMainSymptomCode',
                getIsLoadingSearchResults: 'ChooseMainSymptomStore/getIsLoadingSearchResults',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            searchSymptomInputValue: {
                get: function(){
                    return this.$store.state["ChooseMainSymptomStore"].searchSymptomInputValue;
                },
                set: function(newValue){
                    this.$store.commit('ChooseMainSymptomStore/setSearchSymptomInputValue', newValue);
                    this.$store.commit('ChooseMainSymptomStore/setActiveChapter', null); // Unselect chapter.
                    this.$store.dispatch('ChooseMainSymptomStore/submitSearchSymptom', newValue).then((response) => {
                        this.$emit('isSearchSymptomResultList');
                    });
                }
            },

            getSelectedMainSymptomCode: {
                get() {
                    return this.$store.getters['ChooseMainSymptomStore/getSelectedMainSymptomCode'];
                },
                set (newVal) {
                    this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', newVal);
                }
            }
        },

        watch: {

            getActiveChapter(newValue, oldValue) {

                let that = this;
                this.$nextTick(() => {

                    if (that.getActiveChapter && that.getHasSubchapters && that.getActiveChapter.subChapters != null) {

                        that.getActiveChapter.subChapters.forEach((currentSubchapter) => {

                            let expansionPanelContentSubchapter = that.$refs['vExpansionPanelContentSubchapterRef_' + currentSubchapter.code];
                            if (expansionPanelContentSubchapter != null && expansionPanelContentSubchapter[0] != null) {

                                let scrollAfterTransition = function (event) {

                                    // scroll when subchapter panel is open
                                    if (expansionPanelContentSubchapter[0].isActive === true && that.shortcutNav.isKeyboardNav === true) {

                                        // for IE11 transitionend
                                        if (event.propertyName !== 'height') {
                                            return;
                                        }

                                        let containerScrollable = document.querySelector('.scrolling-content');

                                        // scroll when reopen a subchapter with crtsymptom
                                        if (that.shortcutNav.crtSymptom && that.$refs['vRadioSymptomsWithSubchaptersRef_' + that.shortcutNav.crtSymptom][0] != null) {
                                            that.symptomsPanelRef = that.$refs['vRadioSymptomsWithSubchaptersRef_' + that.shortcutNav.crtSymptom][0];

                                            if (that.symptomsPanelRef.$parent != null
                                                && that.symptomsPanelRef.$parent.$parent != null
                                                && that.symptomsPanelRef.$parent.$parent.$el.offsetTop != null) {

                                                containerScrollable.scrollTop = that.symptomsPanelRef.$parent.$parent.$el.offsetTop + that.symptomsPanelRef.$el.offsetTop - 150;
                                            }
                                        }
                                        // scroll when no crtsymptom
                                        else if (!that.shortcutNav.crtSymptom) {
                                            containerScrollable.scrollTop = expansionPanelContentSubchapter[0].$el.offsetTop - 10;
                                        }
                                    }
                                };

                                expansionPanelContentSubchapter[0].$el.addEventListener("transitionend", scrollAfterTransition);
                                // for Safari <= 6.0
                                expansionPanelContentSubchapter[0].$el.addEventListener("webkittransitionend", scrollAfterTransition);
                            }

                            let subchapterExpansionPanelHeader = that.$refs['vExpansionPanelHeader_' + currentSubchapter.code];
                            if (subchapterExpansionPanelHeader != null && subchapterExpansionPanelHeader[0] != null) {

                                subchapterExpansionPanelHeader[0].parentElement.onclick = function () {
                                    that.onSubchapterPanelClick(currentSubchapter.code);
                                };
                            }

                            let subchapterExpansionPanelBody = that.$refs['vExpansionPanelBody_' + currentSubchapter.code];
                            if (subchapterExpansionPanelBody != null && subchapterExpansionPanelBody[0] != null) {

                                subchapterExpansionPanelBody[0].$el.parentElement.onclick = function () {
                                    that.onSymptomWithoutSubchapterPanelClick(currentSubchapter.code);
                                };
                            }
                        });

                        setTimeout(function() {
                            let symptomSection = document.getElementsByClassName('scrolling-main-symptom-page');
                            let inputSelected = symptomSection[0].getElementsByClassName('input-group--active');
                            if (inputSelected.length > 0) {
                                let radio = inputSelected[0].getElementsByClassName('icon--radio');
                                radio[0].innerHTML = that.radioButtonPlugin();
                            }
                        }, 10);
                    }
                    else if (that.getActiveChapter && !that.getHasSubchapters) {

                        let symptomPanel = that.$refs['vCardSymptomPanelRef'];
                        if (symptomPanel != null) {

                            symptomPanel.$el.onclick = function () {
                                that.shortcutNav.crtPanel = "SYMPTOM";
                            };

                            setTimeout(function() {
                                let symptomSection = document.getElementsByClassName('scrolling-main-symptom-page');
                                let inputSelected = symptomSection[0].getElementsByClassName('input-group--active');
                                if (inputSelected.length > 0) {
                                    let radio = inputSelected[0].getElementsByClassName('icon--radio');
                                    radio[0].innerHTML = that.radioButtonPlugin();
                                }
                            }, 10);

                            // When returning to Main Symptom Page, the focus will remain on the last selected item
                            // We verify if the main symptom belongs to the active chapter and if it does scroll into view
                           that.navScrollIntoViewMainSymptom(newValue, oldValue, symptomPanel);
                        }
                    }
                });

            },

            getSearchSymptomResultList(newValue, oldValue) {

                if (this.getSearchSymptomResultList.length) {

                    let searchResultPanel = this.$refs['vCardSearchResultRef'];
                    if (searchResultPanel != null) {

                        let that = this;
                        searchResultPanel.$el.onclick = function () {

                            that.shortcutNav.crtPanel = "SEARCH";
                        }
                    }
                }
            },

            getSelectedMainSymptomCode (newVal, oldValue) {
                if(newVal) {

                    let that = this;
                    setTimeout(function() {
                        let symptomSection = document.getElementsByClassName('scrolling-main-symptom-page')
                        let inputSelected = symptomSection[0].getElementsByClassName('input-group--active');
                        let radio = inputSelected[0].getElementsByClassName('icon--radio');
                        radio[0].innerHTML = that.radioButtonPlugin();
                    },10)
                }
            }

        },

        methods: {

            handleSymptomSelection (newSelectedSymptomCode) {
                this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', newSelectedSymptomCode);
                this.onSymptomClick(newSelectedSymptomCode);

                axios.post(process.env.API_BASE_URL + '/assessment/clickMainSymptom', {
                    symptomCode: newSelectedSymptomCode
                });
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            onSubchapterPanelClick(subchapterCode) {

                // handle click
                if (this.getActiveChapter && this.getHasSubchapters) {
                    this.shortcutNav.crtPanel = "SUBCHAPTER";

                    if (this.shortcutNav.crtSubchapter !== subchapterCode) {
                        this.shortcutNav.crtSubchapter = subchapterCode;
                        this.shortcutNav.crtSymptom = null;
                    }
                }
            },

            onSymptomClick(symptomCode) {

                if (this.getActiveChapter) {
                    this.shortcutNav.crtPanel = "SYMPTOM";
                    this.shortcutNav.crtSymptom = symptomCode;
                }
            },

            onSymptomWithoutSubchapterPanelClick(currentSubchapterCode) {

                this.shortcutNav.crtPanel = "SYMPTOM";

                if (this.shortcutNav.crtSubchapter != currentSubchapterCode) {

                    this.shortcutNav.crtSubchapter = currentSubchapterCode;
                    this.shortcutNav.crtSymptom = null;
                }
            },

            /**
             * Checks if currently selected main symptom (if any) belongs to the subchapter given as parameter.
             * @param {Object} subchapterObj
             * @return {boolean}
             */
            navMustShowSubchapterExpanded(subchapterObj) {

                let mainSymptomInSubchapter = null;

                subchapterObj.symptoms.forEach((symptom) => {
                    if (symptom.code === this.getSelectedMainSymptomCode) {
                        mainSymptomInSubchapter = symptom.code;
                    }
                });

                if (mainSymptomInSubchapter != null) {

                    let subchapterExpansionPanel = this.$refs['vExpansionPanelContentSubchapterRef_' + subchapterObj.code];

                    if (subchapterExpansionPanel != null) {

                        if (subchapterExpansionPanel.length > 0 && subchapterExpansionPanel[0] != null) {

                            return (subchapterExpansionPanel[0].isActive === true) ? true : false;
                        }
                        // change active chapter => open the subchapter panel with the main symptom (but is not render yet)
                        else if (subchapterExpansionPanel.length === 0) {
                            return true;
                        }
                    }
                    else {
                        let that = this;
                        this.$nextTick(() => {

                            let containerScrollable = document.querySelector('.scrolling-content');

                            if (that.$refs['vRadioSymptomsWithSubchaptersRef_' + that.getSelectedMainSymptomCode][0] != null) {

                                that.symptomsPanelRef = that.$refs['vRadioSymptomsWithSubchaptersRef_' + that.getSelectedMainSymptomCode][0];

                                if (this.symptomsPanelRef.$parent != null
                                    && this.symptomsPanelRef.$parent.$parent != null
                                    && this.symptomsPanelRef.$parent.$parent.$parent != null
                                    && this.symptomsPanelRef.$parent.$parent.$parent.$el.offsetTop != null) {

                                    containerScrollable.scrollTop = that.symptomsPanelRef.$parent.$parent.$parent.$el.offsetTop + that.symptomsPanelRef.$el.offsetTop - 30;
                                }
                            }
                        });

                        // use when we came back to ChooseMainSymptom page
                        this.shortcutNav.crtPanel = "SUBCHAPTER";
                        this.shortcutNav.crtSubchapter = subchapterObj.code;
                        this.shortcutNav.crtSymptom = this.getSelectedMainSymptomCode;

                        return true;
                    }
                }
                else {
                    return false;
                }
            },

            navExpandSubchapter(subchapterCode) {

                if (this.shortcutNav.isKeyboardNav && this.shortcutNav.crtSubchapter === subchapterCode) {

                    // On Shift key down open Symptom panel
                    if (this.shortcutNav.isPanelHighlight === false && this.shortcutNav.crtPanel === 'SYMPTOM') {
                        return true;
                    }
                    // On Shift key up close Subchapter panel
                    else if (this.shortcutNav.isPanelHighlight === true && this.shortcutNav.crtPanel === 'SUBCHAPTER') {
                        return false;
                    }
                }
                // On other cases keep the panel state
                else  {
                    let subchapterExpansionPanel = this.$refs['vExpansionPanelContentSubchapterRef_' + subchapterCode];

                    if (subchapterExpansionPanel != null) {

                        if (subchapterExpansionPanel.length > 0 && subchapterExpansionPanel[0] != null) {
                            return (subchapterExpansionPanel[0].isActive === true) ? true : false;
                        }
                    }
                }
            },

            navSetCursorOnSearchInput() {

                // When focus place cursor at the end text field for IE11
                if (document.getElementById("inputSearchSymptomId") != null) {

                    let textFieldPidId = document.getElementById("inputSearchSymptomId");
                    let pidLength = textFieldPidId.value.length;

                    textFieldPidId.selectionStart = pidLength;
                    textFieldPidId.selectionEnd = pidLength;
                }
            },

            navScrollIntoViewMainSymptom(newValue, oldValue, symptomPanel) {

                let mainSymptomInChapter = this.getActiveChapter.symptoms.findIndex((symptom) => {
                    return symptom.code === this.getSelectedMainSymptomCode;
                });

                if (newValue && !oldValue && mainSymptomInChapter >= 0) {

                    this.shortcutNav.crtPanel = "SYMPTOM";
                    this.shortcutNav.crtSymptom = this.getSelectedMainSymptomCode;

                    if (this.$refs['vRadioSymptomsWithoutSubchaptersRef_' + this.shortcutNav.crtSymptom][0] != null) {

                        let radioSymptomPanel = this.$refs['vRadioSymptomsWithoutSubchaptersRef_' + this.shortcutNav.crtSymptom][0];

                        let containerScrollable = document.querySelector('.scrolling-content');
                        containerScrollable.scrollTop = symptomPanel.$el.offsetTop + radioSymptomPanel.$el.offsetTop - 100;
                    }
                }
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/
        }
}
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    /* ... */


    .input-searchSymptom.input-group.input-group--solo {

        label {
            font-size: $font-size-default;
            top: 5px;
        }

        .input-group__input {
            padding: 0;
            color: $color-on-primary;

            i {
                padding: 8px;
                background-color: $color-gray-lightest;
                color: $color-body-text;
            }

            input {
                padding-left: 15px;
                font-size: $font-size-default;
            }

        }
    }


    /*.no-chapter-list.card {
        margin-top: 45px;
        min-height: 560px;
        box-shadow: none;
        border-radius: 5px;
        margin-bottom: 50px;

        .card__text{
            color: $color-headings-text;
            font-weight: $font-weight-bold;
            font-size: $font-size-medium;
            padding: 24px 10px;
        }

        .input-group {

            label {
                font-size: $font-size-default !important;
            }

            .input-group--active label {
                color: $color-headings-text;
            }
        }

    }*/

    /*@media only screen and (min-width: 1300px) {*/
    /*    .input-group.input-group--solo.input-searchSymptom {*/
    /*        float: right;*/
    /*        width: 50%;*/
    /*        margin-bottom: 28px;*/
    /*        min-height: 40px;*/
    /*    }*/

    /*}*/

    /*@media only screen and (max-width: 1299px) {*/
    /*    .input-group.input-group--solo.input-searchSymptom {*/
    /*        float: right;*/
    /*        width: 100%;*/
    /*        margin-bottom: 17px;*/
    /*        min-height: 40px;*/
    /*    }*/

    /*}*/

    /*@media only screen and (max-width: 960px) {*/
    /*    .input-group.input-group--solo.input-searchSymptom {*/
    /*        float: right;*/
    /*        width: 100%;*/
    /*        margin-bottom: 17px;*/
    /*        min-height: 40px;*/
    /*    }*/

    /*}*/

    .synonyms:first-of-type {
        padding-left: 2.5em;
    }
    .synonyms + .synonyms:before {
        content: ", ";
    }


</style>




// WEBPACK FOOTER //
// src/professional/components/choose-main-symptom/Symptoms.vue